(function () {
    'use strict';

    angular
        .module('app')
        .controller('XeroIntegration', XeroIntegration);

    XeroIntegration.$inject = ['$location', '$http', '$window', 'DialogService', 'ChilliUserProfileService', 'WindowTitleService', 'UrlService'];

    function XeroIntegration($location, $http, $window, DialogService, ChilliUserProfileService, WindowTitleService, UrlService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.onXeroConnectClick = onXeroConnectClick;
        vm.onXeroDisconnectClick = onXeroDisconnectClick;
        vm.integrationInfo = null;

        activate();

        function activate() {
            WindowTitleService.setTitle('Xero Integration');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: onUserIsAdmin,
                onUserIsNotAdmin: function () {
                    vm.permissionDenied = true;
                    vm.loading = false;
                },
                onError: function (response) {
                    DialogService.error('Error loading User profile', response);
                    vm.loading = false;
                }
            });
        }

        function onUserIsAdmin() {
            var queryString = $location.search();

            if (queryString.code) {
                // Xero authorisation has provided an OAuth code, we need to process that...

                $http.post(UrlService.getWebAPIUrl() + '/XeroAuthorisation/ProcessCode', JSON.stringify(queryString.code)).then(
                    function ok() {
                        $location.search('');
                        loadAuthInfo();
                    },
                    function error(response) {
                        DialogService.error('Error processing Xero access code.', response);
                        vm.loading = false;
                    });
            } else {
                loadAuthInfo();
            }
        }

        function loadAuthInfo() {
            $http.get(UrlService.getWebAPIUrl() + '/XeroAuthorisation').then(
                function ok(response) {
                    vm.integrationInfo = response.data;
                    vm.loading = false;
                }, function error(response) {
                    DialogService.error('Error fetching Xero authorisation data.', response);
                    vm.loading = false;
                });
        }

        function onXeroConnectClick() {
            $window.location.href = vm.integrationInfo.ConnectUri;
        }

        function onXeroDisconnectClick() {
            $http.post(UrlService.getWebAPIUrl() + '/XeroAuthorisation/DeleteConnections').then(
                function ok(response) {
                    if (!response.data.DeletedConnections && !response.data.DeletedToken) {
                        DialogService.error('Failed to delete Xero connection. ' + response.data.ErrorMessages);
                    } else if (!response.data.DeletedConnections) {
                        DialogService.error('Xero token was deleted, but app registration in Xero remains. You may need to manually remove the registration from Xero. ' + response.data.ErrorMessages);
                    } else if (!response.data.DeletedToken) {
                        DialogService.error('Xero app registration was deleted, but token remains. You may need to retry the disconnect process. ' + response.data.ErrorMessages);
                    }

                    loadAuthInfo();
                },
                function error(response) {
                    DialogService.error('Error deleting Xero connection.', response);
                });
        }
    }
})();
